module.exports = __webpack_public_path__ + "static/media/pattern.926e4b61.png";